import { generateRandomId } from "@kalyzee/kast-web-sdk";
import { addComponentOnOverlay, removeComponentOnOverlay } from "@kalyzee/kast-web-sdk/web-components";
import React from "react";

export interface PopupDisplayInfo { component: React.ReactNode, tag: string, group?: string, key: string}

var currentPopups: PopupDisplayInfo[] = [];
export const addPopup = (component: React.ReactNode, tag: string, group?: string,) => {
  const info: PopupDisplayInfo = {
    component,
    tag,
    group,
    key: `${tag}_${generateRandomId()}`,
  };
  currentPopups.push(info);
  addComponentOnOverlay(component, info.key);
};



export const removePopup = (component: React.ReactNode) : PopupDisplayInfo | undefined => {
  let found: PopupDisplayInfo | undefined = undefined;
  currentPopups.filter((p) => {
    if (p.component === component) {
      found = p;
      return false;
    }
    return true;
  })
  if (found) removeComponentOnOverlay(component);
  return found;
};

export const removePopups = (selector: (curr: PopupDisplayInfo) => boolean) : PopupDisplayInfo[] => {
  let toRemove: PopupDisplayInfo[] = [];
  currentPopups.filter((p) => {
    if (selector(p)) {
      toRemove.push(p);
      return false;
    }
    return true;
  })
  toRemove.forEach((p) => removeComponentOnOverlay(p.component));
  return toRemove;
};

export const removePopupByTag = (tag: string): PopupDisplayInfo[] => {
  return removePopups((p) => p.tag === tag);
};


export const removePopupByGroup = (group: string): PopupDisplayInfo[] => {
  return removePopups((p) => p.group === group);
};



